import actionTypes from '../actions/actionTypes';

export default function newRequestReducer(state = {}, { type, data }) {
  let newState = null;

  switch (type) {
    case actionTypes.LOAD_ERROR:
      newState = { ...state, error: data };
      break;
    case actionTypes.SET_REQUEST_DATA:
      let val = typeof data.value === 'string' ? data.value.trimLeft() : data.value;
      newState = {
        ...state,
        newRequestData: { ...state.newRequestData, [data.id]: val },
      };
      break;
    case actionTypes.EMPTY_NEW_REQUEST_DATA:
      newState = {
        ...state,
        newRequestData: { cars: [{}] },
      };
      break;
    default:
      newState = state;
      break;
  }

  return newState;
}
